// lingland-frontend/src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title,
    description,
    name = "Lingland",
    type = "website",
    imageUrl,
    url,
    structuredData = null // Może być obiektem lub tablicą obiektów
}) => {
    const fullTitle = `${title} | Lingland`;
    const defaultDescription = "Lingland - Nowoczesne biuro tłumaczeń online. Specjalizujemy się w tłumaczeniach pisemnych, lokalizacji, audio-wideo. Gwarancja jakości i profesjonalizmu.";
    const finalDescription = description || defaultDescription;
    const siteUrl = "https://lingland.pl";
    const canonicalUrl = url ? `${siteUrl}${url}` : siteUrl;
    // Użyj przekazanego imageUrl jeśli jest, w przeciwnym razie domyślny. Upewnij się, że jest to pełny URL.
    const defaultSiteImage = `${siteUrl}/logo512.png`;
    let finalImageUrl = imageUrl;
    if (finalImageUrl && !finalImageUrl.startsWith('http')) {
        finalImageUrl = `${siteUrl}${finalImageUrl.startsWith('/') ? '' : '/'}${finalImageUrl}`;
    }
    finalImageUrl = finalImageUrl || defaultSiteImage;

    return (
        <Helmet>
            {/* Standardowe meta tagi */}
            <title>{fullTitle}</title>
            <meta name="description" content={finalDescription} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={finalDescription} />
            <meta property="og:site_name" content={name} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={finalImageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:locale" content="pl_PL" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={finalDescription} />
            <meta name="twitter:image" content={finalImageUrl} />
            
            {/* Dane Strukturalne (Schema.org) */}
            {structuredData && Array.isArray(structuredData) ? (
                structuredData.map((data, index) => (
                    data && <script key={index} type="application/ld+json">
                        {JSON.stringify(data)}
                    </script>
                ))
            ) : structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;